import type { NextRouter } from 'next/router';
import { getVoucherPriceDiscountPercent } from '../components/VoucherPrice/helpers';

export function extractQueryParameter(query: NextRouter['query']) {
  return {
    /**
     * This function returns the voucher price discount in percentage, if `isVoucherPriceEnabled` is true
     * and the query params have the corresponding value.
     *
     * Example: ?Name=xx_GHRabatt2_xx maps to 2% discount.
     *
     * @returns - The voucher price discount in percentage as `number` or `null`
     */
    voucherPriceDiscount: getVoucherPriceDiscountPercent(query),
  };
}
